import React, { useState } from 'react'
import { Card, Tabs } from 'antd'
import { ClusterOutlined } from '@ant-design/icons'
import GlobalHeader from '../../common/components/Header/GlobalHeader'
import PageHeader from '../../common/components/Header/PageHeader'
import ReferenceDataCrudPage from '../../common/components/ReferenceData/ReferenceDataCrudPage'
import { departmentService } from '../../common/service/department.service'
import { roleService } from '../../common/service/role.service'

function Department() {
	const [activeTab, setActiveTab] = useState('departments')

	return (
		<>
			<GlobalHeader />

			<PageHeader
				title='Roles & Departments'
				subtitle='Manage staff roles and departments'
				icon={<ClusterOutlined />}
			/>

			<div style={{ padding: '12px 24px 24px' }}>
				<Card style={{ borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
					<Tabs
						activeKey={activeTab}
						onChange={setActiveTab}
						items={[
							{
								key: 'departments',
								label: 'Departments',
								children: (
									<ReferenceDataCrudPage
										embedded
										title='Departments'
										singularLabel='Department'
										idFieldLabel='Department ID'
										nameFieldLabel='Department Name'
										service={departmentService}
									/>
								),
							},
							{
								key: 'roles',
								label: 'Roles',
								children: (
									<ReferenceDataCrudPage
										embedded
										title='Roles'
										singularLabel='Role'
										idFieldLabel='Role ID'
										nameFieldLabel='Role Name'
										service={roleService}
									/>
								),
							},
						]}
					/>
				</Card>
			</div>
		</>
	)
}

export default Department
